import { Source, ViewMode } from "utils/interfaces"

export function makeSource(mode: ViewMode | null = null): Source {
    if (!mode) {
        const searchParams = new URL(window.location.toString()).searchParams
        mode = (searchParams.get("mode") as ViewMode) || "unknown"
    }
    return {
        mode,
        search_terms: {},
    }
}
